import { PageRoute } from "./PageRoute";

export function GetRouteByName(name: string) {
  return mainRoutes.find((item) => item.Name === name)?.Route;
}

export const newsRoutes: PageRoute[] = [
  { Name: "Test1", Route: "/", IsMainRoute: true },
  { Name: "Test2", Route: "/", IsMainRoute: true },
  { Name: "Test3", Route: "/", IsMainRoute: true },
  { Name: "Test4", Route: "/", IsMainRoute: true },
];

export const mainRoutes: PageRoute[] = [
  { Name: "Home", Route: "/", IsMainRoute: true },
  { Name: "Bio", Route: "/bio", IsMainRoute: true },
  { Name: "Servizi", Route: "/servizi", IsMainRoute: true },
  { Name: "News", Route: "/", IsMainRoute: false, SubRoutes: newsRoutes },
  { Name: "Contatti", Route: "/contatti", IsMainRoute: true },
];
